<template style="background: white">
  <div class="goods">
    <van-swipe class="goods-swipe" :autoplay="3000" style="height:200px;">
      <van-swipe-item v-for="thumb in goods.thumb" :key="thumb">
        <img :src="thumb" >
      </van-swipe-item>
    </van-swipe>
    <van-notice-bar
        left-icon="volume-o"
        text="-------------------"
    />
    <van-grid :border="false" icon-size="35">
      <van-grid-item icon="https://qducc.oss-cn-qingdao.aliyuncs.com/zf_icon/mall/%E5%AE%9A%E6%97%B6%E6%8A%BD%E5%A5%96.png" text="抽奖" />
      <van-grid-item icon="https://qducc.oss-cn-qingdao.aliyuncs.com/zf_icon/mall/%E7%A0%8D%E4%BB%B7.png" text="砍价" />
      <van-grid-item icon="https://qducc.oss-cn-qingdao.aliyuncs.com/zf_icon/mall/%E7%A7%AF%E5%88%86%E5%95%86%E5%9F%8E.png" text="积分" />
      <van-grid-item icon="https://qducc.oss-cn-qingdao.aliyuncs.com/zf_icon/mall/%E9%A2%84%E7%BA%A6%E5%88%B0%E5%BA%97.png" text="预约" />
    </van-grid>
    <van-grid :border="false"  :column-num="3" style="margin-top:10px;">
      <van-grid-item>
        <van-image src="https://img01.yzcdn.cn/vant/apple-1.jpg" />
      </van-grid-item>
      <van-grid-item>
        <van-image src="https://img01.yzcdn.cn/vant/apple-2.jpg" />
      </van-grid-item>
      <van-grid-item>
        <van-image src="https://img01.yzcdn.cn/vant/apple-3.jpg" />
      </van-grid-item>
    </van-grid>
    {{content}}
    <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
    >
        <van-card
            tag="标签"
            price="2.00"
            desc="赞前端团队维护的移动端组件库，提供了一整套 UI 基础组件和业务组件。介绍 轻量、可靠的移动端 Vue 组件库，采用 MIT 开源协议, 目前github star 数9k+，是有赞的一套开源组"
            title="商品标题"
            thumb="https://img01.yzcdn.cn/vant/ipad.jpeg"
            origin-price="10.00"
        />
      <van-card
          tag="标签"
          price="2.00"
          desc="描述信息123123123123lasjdflkadjf描述信息123123123123lasjdflkadjf描述信息123123123123lasjdflkadjf"
          title="商品标题"
          thumb="https://img01.yzcdn.cn/vant/ipad.jpeg"
          origin-price="10.00"
      />
      <van-card
          tag="标签"
          price="2.00"
          desc="描述信息123123123123lasjdflkadjf描述信息123123123123lasjdflkadjf描述信息123123123123lasjdflkadjf"
          title="商品标题"
          thumb="https://img01.yzcdn.cn/vant/ipad.jpeg"
          origin-price="10.00"
      />
    </van-list>
  </div>
</template>

<script>
import {
  Tag,
  Col,
  Icon,
  Cell,
  CellGroup,
  Swipe,
  Toast,
  SwipeItem,
  Card,
  List,
  Grid,
  GridItem,
  Image,
  NoticeBar,
} from 'vant';

export default {
  components: {
    [Tag.name]: Tag,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Card.name]: Card,
    [List.name]: List,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Image.name]: Image,
    [NoticeBar.name]: NoticeBar,
  },

  data() {
    return {
      goods: {
        title: '美国伽力果（约680g/3个）',
        price: 2680,
        express: '免运费',
        remain: 19,
        thumb: [
          'https://img.yzcdn.cn/public_files/2017/10/24/e5a5a02309a41f9f5def56684808d9ae.jpeg',
          'https://img.yzcdn.cn/public_files/2017/10/24/1791ba14088f9c2be8c610d0a6cc0f93.jpeg'
        ]
      },
      list: [1,2,3,],
      loading: false,
      finished: false,
      content: ''
    };
  },
  created() {
    this.finished = true
  },
  methods: {
    formatPrice() {
      return '¥' + (this.goods.price / 100).toFixed(2);
    },
    onLoad() {

    },
    onClickCart() {
      this.$router.push('cart');
    },

    sorry() {
      Toast('暂无后续逻辑~');
    }
  }
};
</script>

<style lang="less">
.van-card__desc {
  max-height: 40px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
}
.van-card{
  background: white;
  padding:10px;
  margin:10px;
  border-radius: 8px;
}
.goods {
  padding-bottom: 50px;
  &-swipe {
    img {
      width: 100%;
      display: block;
    }
  }

  &-title {
    font-size: 16px;
  }

  &-price {
    color: #f44;
  }

  &-express {
    color: #999;
    font-size: 12px;
    padding: 5px 15px;
  }

  &-cell-group {
    margin: 15px 0;

    .van-cell__value {
      color: #999;
    }
  }

  &-tag {
    margin-left: 5px;
  }
}
</style>
